<div class='card card-primary'>
    <div class='card-header'>
        <div class="row">
            <div class="col-sm-6">
                Active Filters &nbsp;                  
                <span class="fa fa-pencil-alt" data-bs-toggle="modal" data-bs-target="#myModal"
                    (click)="editFilters()"></span>
            </div>
            <div class="col-sm-6">
                <!-- <span style='float: right! important; font-size: 18px;' class="fas" [ngClass]="{'fa-angle-down': minimizeAppliedFilters, 'fa-angle-up': !minimizeAppliedFilters }"
                      (click)="minimizeAppliedFilters = !minimizeAppliedFilters"></span> -->
            </div>
        </div>
    </div>
    <!-- <div class='card-body' *ngIf="!minimizeAppliedFilters"> -->
    <div class='card-body'>
        <dashboard-filter [open]="showFilters" [filter]="filter" (close)="closeFilters()"
                (filterChanged)="handleFilterChanged($event)">
        </dashboard-filter>
    </div>
</div>

    <!-- <kendo-grid 
    #grid
    [navigable]="true">

    <kendo-grid-command-column [width]="150">
      <ng-template kendoGridCellTemplate let-isNew="isNew">
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid> -->
